<template>
  <div class="space-y-4">
    <EmailAddressesProperty :contact-id="contactId" />
    <PhoneNumbersProperty :contact-id="contactId" />
  </div>
</template>

<script>
import EmailAddressesProperty from './contactProperties/EmailAddressesProperty.vue';
import PhoneNumbersProperty from './contactProperties/PhoneNumbersProperty.vue';

export default {
  components: {
    EmailAddressesProperty,
    PhoneNumbersProperty,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
};
</script>
